"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Defines possible links policies.
 */
var LinksPolicy;
(function (LinksPolicy) {
    /**
     * Defines that only predicates that are marked with hydra:Link or hydra:TemplatedLink are considered a link.
     * @enum
     */
    LinksPolicy[LinksPolicy["Strict"] = 0] = "Strict";
    /**
     * Defines that all resources in a relation pointing to the same protocol, host and port are considered a link.
     * @enum
     */
    LinksPolicy[LinksPolicy["SameRoot"] = 1] = "SameRoot";
    /**
     * Defines that all non-blank HTTP/HTTPS resources in a relation are considered a link.
     * @enum
     */
    LinksPolicy[LinksPolicy["AllHttp"] = 2] = "AllHttp";
    /**
     * Defines that all non-blank resources in a relation are considered a link.
     * @enum
     */
    LinksPolicy[LinksPolicy["All"] = 3] = "All";
})(LinksPolicy = exports.LinksPolicy || (exports.LinksPolicy = {}));
//# sourceMappingURL=LinksPolicy.js.map